import { useTranslation } from 'react-i18next';

import { localStorageKeys } from '@/shared/utils/constants';
import ROUTES from '../../App/Router/Routes';

import { type RecentBuilding } from '~/common/types/building';

import { BuildingIcon } from '@/shared/icons/Icons';
import RecentSidebarContent from './RecentSideBarContent';

const BuildingSidebarContent: React.FC = () => {
  const { t } = useTranslation();

  // BuildingDetail redirects to the homeowner association while it's active; the cached id can be stale.
  const getRoute = (building: RecentBuilding) => `/building/${building.id}`;

  return (
    <RecentSidebarContent<RecentBuilding>
      getItemRoute={getRoute}
      getItemTitle={(building) => building.name}
      getItemTooltip={(building) => building.name}
      icon={<BuildingIcon />}
      mainRoute={ROUTES.BUILDINGS_OVERVIEW}
      storageKey={localStorageKeys.recentBuildings}
      title={t('building_other')}
    />
  );
};

export default BuildingSidebarContent;
